var r="Ой, щось пішло не так",n={unknownError:r};export{n as default,r as unknownError};
//# sourceMappingURL=errors.js.map